import { render, staticRenderFns } from "./MobileAppBar.vue?vue&type=template&id=2c213a7c&scoped=true"
import script from "./MobileAppBar.vue?vue&type=script&lang=js"
export * from "./MobileAppBar.vue?vue&type=script&lang=js"
import style0 from "./MobileAppBar.vue?vue&type=style&index=0&id=2c213a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c213a7c",
  null
  
)

export default component.exports